import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import * as usersActions from './reducer';
import * as groupsActions from '../groups/reducer';

import User from './User';

import './Users.css';

export class UsersComponent extends Component {
  static get propTypes() {
    return {
      fetching: PropTypes.bool,
      users: PropTypes.array,
      groups: PropTypes.array,
      onFetch: PropTypes.func.isRequired,
      onFetchGroups: PropTypes.func.isRequired,
      addUserToGroup: PropTypes.func.isRequired,
      removeUserFromGroup: PropTypes.func.isRequired
    };
  }

  constructor(props) {
    super(props);
    props.onFetch();
    props.onFetchGroups();

    this.state = {
      users: props.users
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      users: props.users
    });
  }

  render() {
    const { fetching } = this.props;
    const { users } = this.state;

    return (
      <div className="AdminUsers">
        { fetching && <div className="fetching">Getting users</div> }
        { users && this.renderUsers(users) }
      </div>
    );
  }

  renderUsers(users) {
    const { addUserToGroup, removeUserFromGroup, groups } = this.props;

    return (<table className="Admin-table AdminUsers-table">
      <tbody>
        <tr>
          <th className="name">Name</th>
          <th className="groups">Groups</th>
        </tr>
        { users.map(u =>
          (<User
            user={u}
            key={u.Id}
            onAddGroup={group => addUserToGroup(u, group)}
            onRemoveGroup={group => removeUserFromGroup(u, group)}
            userGroups={this.getGroupsForUser(u)}
            allGroups={groups}
          />)
        ) }
      </tbody>
    </table>);
  }

  getGroupsForUser(user) {
    const { groups } = this.props;
    return groups &&
        groups.filter(g => g.Users && g.Users.find(u => u.Id === user.Id));
  }
}

const mapStateToProps = state => ({
  fetching: state.admin.users.fetching,
  users: state.admin.users.users,
  groups: state.admin.groups.groups
});

const mapDispatchToProps = (dispatch) => {
  const {
    fetchUsersIfNeeded
  } = bindActionCreators(usersActions, dispatch);

  const {
    fetchGroupsIfNeeded,
    addUserToGroup,
    removeUserFromGroup
  } = bindActionCreators(groupsActions, dispatch);

  return {
    onFetch: fetchUsersIfNeeded,
    onFetchGroups: fetchGroupsIfNeeded,
    addUserToGroup,
    removeUserFromGroup
  };
};

const Users = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersComponent));
export default Users;



// WEBPACK FOOTER //
// ./src/admin/users/Users.js